// extracted by mini-css-extract-plugin
export var authorDetails = "blogAuthor-module--authorDetails--22882";
export var authorImage = "blogAuthor-module--authorImage--444be";
export var authorImageFrame = "blogAuthor-module--authorImageFrame--d7c57";
export var authorName = "blogAuthor-module--authorName--413ec";
export var dark = "blogAuthor-module--dark--309e4";
export var klaviyoLogo = "blogAuthor-module--klaviyoLogo--84959";
export var noImage = "blogAuthor-module--noImage--c03ce";
export var row = "blogAuthor-module--row--34d27";